var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv1-2.jpg",
      "scroll": "false"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap mb-30 mb-lg-54"
  }, [_c('div', {
    staticClass: "text-ani mb-14 mb-lg-28"
  }, [_c('h5', {
    staticClass: "tit-txt line-height-1"
  }, [_vm._v("세일즈웍스 그룹 아시아 ")])]), _c('div', {
    staticClass: "text-ani mb-8 mb-lg-20"
  }, [_c('h2', {
    staticClass: "font-weight-bold font-size-40 font-size-md-54 font-size-lg-80 line-height-1"
  }, [_vm._v("제임스 그리브즈")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('p', {
    staticClass: "page-text--sm color-grey-d line-height-1"
  }, [_vm._v("Executive Chairman")])])]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 세일즈웍스는 업계 선두 주자로서 수많은 캠페이너와 성과를 배출해온 기업입니다. "), _c('br'), _vm._v(" 가능성과 잠재력을 중시하는 자세로 교육과 트레이닝을 통해 인재를 양성해왔습니다. "), _c('br'), _vm._v(" 안주하기보다는 도전하며, 성장에 집중하는 기업이 되기 위해 노력하고 있습니다. ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }